import { Currency } from '../enums/Currency';

const currencyMapping: Record<Currency, string> = {
    [Currency.UNKNOWN]: ' ',
    [Currency.RUB]: '₽',
    [Currency.USD]: '$',
    [Currency.EUR]: '€'
};

export { currencyMapping };
